import { useDispatch } from 'react-redux';

import { trackCtaButtonClicked } from '../actions';

/**
 * Custom hook for tracking CTA button clicks
 * @returns {Function} Dispatch function for tracking button clicks
 */
const useTrackCtaButtonClick = () => {
  const dispatch = useDispatch();

  return (trackingData) => {
    dispatch(trackCtaButtonClicked(trackingData));
  };
};

export default useTrackCtaButtonClick;
